export default function loadTypes(name) {
  const types = [`${name}_REQUEST`, `${name}_SUCCESS`, `${name}_FAILURE`]
  types['REQUEST'] = types[0]
  types['SUCCESS'] = types[1]
  types['FAILURE'] = types[2]

  return types
}



// WEBPACK FOOTER //
// ./client/utils/loadTypes.js